<template>
    <!--
    作者：bbc_team
    时间：2023-06-08
    描述：插件中心-积分商城-商品设置-编辑商品-规格
  -->
    <div>
        <div class="common-form">规格</div>
        <el-form-item label="批量设置" prop="tableData" :rules="rulesGoods">
            <div class="d-s-c pt16 max-w460 active-all-set">
                <div class="flex-1"><el-input v-model="all_money" type="number" min="0" placeholder="砍到底价"></el-input></div>
                <div class="flex-1 ml10"><el-input v-model="all_num" type="number" min="0" placeholder="砍价人数"></el-input></div>
                <div class="flex-1 ml10"><el-input v-model="all_stock" type="number" min="0" placeholder="活动库存"></el-input></div>
                <div class="ml10"><el-button @click="allApply">应用</el-button></div>
            </div>
            <div class="pt16">
                <el-table size="mini" :data="form.tableData" :span-method="objectSpanMethod" border style="width: 100%;">
                    <el-table-column label="商品名称" width="300">
                        <template slot-scope="scope">
                            <p class="text-ellipsis-2">{{ scope.row.goods_name }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="规格" width="180">
                        <template slot-scope="scope">
                            <div v-if="scope.row.spec_type == 10" class="gray">暂无规格</div>
                            <div v-if="scope.row.spec_type == 20">
                                <div v-if="scope.row.spec_name != null && scope.row.spec_name != ''" class="spec-min-box">
                                    <p class="text-ellipsis" :title="scope.row.spec_name">{{ scope.row.spec_name }}</p>
                                    <i class="el-icon-close" @click="deleteClick(scope.$index)"></i>
                                    <i class="el-icon-caret-right" @click="specsFunc(scope.$index, scope.row, true)"></i>
                                </div>
                                <el-button v-else size="mini" icon="el-icon-plus" @click="specsFunc(scope.$index, scope.row)">添加规格</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goods_price" label="售价"></el-table-column>
                    <el-table-column label="砍到底价">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.bargain_price" size="small" type="number" min="0" step="1"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="砍价人数">
                        <template slot-scope="scope">
                            <el-form-item label="" style="margin-bottom: 0;"><el-input v-model="scope.row.bargain_num" size="small" type="number" min="0" step="0.01"></el-input></el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="活动库存">
                        <template slot-scope="scope">
                            <el-form-item label="" style="margin-bottom: 0;"><el-input v-model="scope.row.bargain_stock" size="small" type="number" min="0" step="0.01"></el-input></el-form-item>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form-item>

        <!--规格选择-->
        <Specs :isspecs="isspecs" :goods-id="curGoods.goods_id" :exclude-ids="SpecExcludeIds" :islist="true" @close="closeSpecs"></Specs>
    </div>
</template>

<script>
    import GoodsApi from "@/api/goods.js";
    import Specs from "@/components/goods/Specs.vue";
    import { mergeTable } from "@/utils/table.js";
    export default {
        components: {
            /*选择规格*/
            Specs
        },
        inject: ["form", "type"],
        data() {
            /*验证公司名称*/
            const validatorGoods = (rule, value, callback) => {
                if (value.length < 1) {
                    return callback(new Error("请选择商品"));
                } else {
                    let flag = false;
                    for (let i = 0; i < this.form.tableData.length; i++) {
                        let item = this.form.tableData[i];

                        if (!flag) {
                            let reg = item.point_price == "" || item.point_stock == "" || item.limit_num == "" || item.sort == "";
                            let reg2 = parseFloat(item.point_price) == 0 || parseInt(item.point_stock) < 1 || parseInt(item.limit_num) < 1 || (item.spec_type == 20 && !item.spec_name);
                            if (reg || reg2) {
                                flag = true;
                            }
                        }

                        if (parseInt(item.point_stock) > 0) {
                            item.stockValid = true;
                        } else {
                            item.stockValid = false;
                        }

                        if (parseInt(item.point_price) > 0) {
                            item.priceValid = true;
                        } else {
                            item.priceValid = false;
                        }

                        if (parseInt(item.limit_num) > 0) {
                            item.limit_numValid = true;
                        } else {
                            item.limit_numValid = false;
                        }

                        if (parseInt(item.sort) > 0) {
                            item.sortValid = true;
                        } else {
                            item.sortValid = false;
                        }
                        this.$set(this.form.tableData, i, item);
                    }
                    if (flag) {
                        return callback(new Error("请填写正确的信息"));
                    } else {
                        callback();
                    }
                }
            };

            return {
                /*产品去重*/
                excludeIds: [],
                /*是否打开规格选择*/
                isspecs: false,
                /*查询规格当前商品*/
                curGoods: {},
                /*当前的角标索引*/
                curIndex: -1,
                /*选择规格*/
                specType: false,
                /*规格去重*/
                SpecExcludeIds: [],
                /*批量兑换金额*/
                all_money: null,
                /*批量限购*/
                all_stock: null,
                /*批量砍价人数*/
                all_num: null,
                /*验证商品*/
                rulesGoods: [{ validator: validatorGoods, required: true, trigger: "blur" }]
            };
        },
        created() {
            this.creatSpec();
        },
        methods: {
            /*关闭弹窗*/
            creatSpec(e) {
                this.form.tableData = mergeTable(this.form.tableData);
            },

            /*打开规格*/
            specsFunc(i, e, type) {
                this.curGoods = e;
                this.curIndex = i;
                let arr = [];

                if (type) {
                    this.specType = true;
                    this.form.tableData.forEach((item) => {
                        if (this.curGoods.goods_id == item.goods_id) {
                            arr.push(item.goods_sku_id);
                        }
                    });
                } else {
                    this.specType = false;
                }
                this.SpecExcludeIds = arr;
                this.isspecs = true;
            },

            /*关闭规格*/
            closeSpecs(e) {
                this.isspecs = false;
                if (e.type == "success") {
                    let arr = [];
                    for (let i = 0; i < e.params.length; i++) {
                        let item = e.params[i];
                        let obj = {
                            goods_name: this.curGoods.goods_name,
                            goods_id: this.curGoods.goods_id,
                            spec_type: this.curGoods.spec_type,
                            goods_sku_id: this.curGoods.goods_sku_id,
                            bargain_goods_id: this.curGoods.bargain_goods_id,
                            goods_price: item.spec_form.goods_price,
                            stock_num: item.goods_stock,
                            sales_num: 0,
                            spec_name: item.spec_name,
                            goods_sku_id: item.goods_sku_id,
                            bargain_price: 0,
                            bargain_stock: 0,
                            bargain_num: 0,
                            tempGoods: true,
                            bargain_goods_sku_id: 0
                        };
                        arr.push(obj);
                    }

                    let params = [this.curIndex, this.specType ? 0 : 1].concat(arr);

                    this.form.tableData.splice(...params);
                    this.form.tableData = mergeTable(this.form.tableData);
                }
            },

            /*删除*/
            deleteClick(e, isType) {
                let curItem = this.form.tableData[e];
                if (isType) {
                    /*判断能删除产品*/
                    for (let i = 0; i < this.form.tableData.length; i++) {
                        let item = this.form.tableData[i];
                        if (curItem.goods_id == item.goods_id) {
                            if (item.sales_num > 0) {
                                this.$message({
                                    message: "已售商品不能删除！",
                                    type: "warning"
                                });
                                return;
                            }
                        }
                    }
                    for (let i = 0; i < this.form.tableData.length; i++) {
                        let item = this.form.tableData[i];
                        if (curItem.goods_id == item.goods_id) {
                            if (this.type == "edit" && e.tempGoods != true) {
                                let point_goods_id = item.point_goods_id;
                                this.form.goods_del_ids.push(point_goods_id);
                            }
                            this.form.tableData.splice(i, 1);
                            i--;
                        }
                    }
                } else {
                    /*删除规格*/
                    if (parseInt(e.sales_num) > 0) {
                        this.$message({
                            message: "已售商品规格不能删除！",
                            type: "warning"
                        });
                        return;
                    }
                    let count = 0;
                    for (let i = 0; i < this.form.tableData.length; i++) {
                        let item = this.form.tableData[i];
                        if (curItem.goods_id == item.goods_id) {
                            count++;
                            if (count > 1) {
                                break;
                            }
                        }
                    }
                    if (count > 1) {
                        this.form.tableData.splice(e, 1);
                    } else {
                        curItem.spec_name = null;
                    }
                }
                this.form.tableData = mergeTable(this.form.tableData);
            },

            /*表格合并行*/
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    if (row.rowSpan != null) {
                        return {
                            rowspan: row.rowSpan,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },

            /*全部应用*/
            allApply() {
                let arr = [];
                for (let i = 0; i < this.form.tableData.length; i++) {
                    let item = this.form.tableData[i];
                    if (item.bargain_price <= 0) {
                        if (parseInt(this.all_money) > parseInt(item.goods_price)) {
                            item.bargain_price = item.goods_price;
                        } else {
                            item.bargain_price = this.all_money;
                        }
                    }
                    item.bargain_num = item.bargain_num <= 0 ? this.all_num : item.bargain_num;
                    item.bargain_stock = item.bargain_stock <= 0 ? this.all_stock : item.bargain_stock;
                }
            },

            /*显示隐藏*/
            showFunc(i, e) {
                if (e.is_delete === 0) {
                    e.is_delete = 1;
                } else {
                    e.is_delete = 0;
                }
            }
        }
    };
</script>

<style lang="scss">
    .spec-min-box > i {
        position: absolute;
        right: 0;
        font-size: 16px;
        cursor: pointer;
    }
    .spec-min-box .el-icon-close {
        top: 0;
        color: red;
        visibility: hidden;
    }
    td:hover .spec-min-box .el-icon-close {
        visibility: visible;
    }
    .spec-min-box .el-icon-caret-right {
        bottom: 0;
        transform: rotate(45deg);
        color: #3a8ee6;
    }
    .el-form-item.is-error .active-all-set .el-input__inner,
    .el-form-item.is-error .isvalid .el-input__inner {
        border-color: #c0c4cc;
    }
</style>



// WEBPACK FOOTER //
// src/views/activity/bargain/part/Spec.vue